import type { MembershipPlanSlug } from '@primetime/shared/apiContracts';
import type { VersionType } from '@primetime/shared';

export const membershipPlans = [
  {
    slug: 'starter-pack' as MembershipPlanSlug,
    name: 'Starter Pack',
    price: '$29.99',
    cadence: '/month',
    credits: 40,
    expirationDays: 30,
    badge: null,
    description: 'Entry access for working DJs and VJs building a focused set toolkit.'
  },
  {
    slug: 'working-dj' as MembershipPlanSlug,
    name: 'Working DJ',
    price: '$49.99',
    cadence: '/month',
    credits: 80,
    expirationDays: 60,
    badge: 'Best Value',
    description: 'More monthly unlock power for active weekly sets and event prep.'
  },
  {
    slug: 'primetime-pro' as MembershipPlanSlug,
    name: 'PrimeTime Pro',
    price: '$99.99',
    cadence: '/month',
    credits: 160,
    expirationDays: 90,
    badge: 'Most Access',
    description: 'Maximum Member Access for high-volume DJ/VJ catalog work.'
  }
];

export function getCreditCost(versionType: VersionType | 'MIX', cleanDirtyBundle = false) {
  // MIX and Video Mix pricing remain unchanged while their unlock flow is out of scope.
  if (versionType === 'MIX' || versionType === 'VIDEO_MIX' || versionType === 'VIDEO_MIXES') return 5;

  // Every normal MP4 is an independently unlockable one-credit TrackVersion.
  // A Clean + Dirty selection is represented by two independent unlocks, so
  // its combined display is the sum of those two newly unlockable versions.
  return cleanDirtyBundle ? 2 : 1;
}

export function formatPrimeTimeCredits(credits: number) {
  return `${credits} PrimeTime ${credits === 1 ? 'Credit' : 'Credits'}`;
}
